import { Icon as BaseIcon } from "@simurgh/feathers/ui/icon";
import type { ComponentProps } from "react";

const ICONS_SPRITE_PATH = "/assets/icons/sprite.symbol.svg";

export function Icon({
	...props
}: Omit<ComponentProps<typeof BaseIcon>, "spriteHref">) {
	return <BaseIcon spriteHref={ICONS_SPRITE_PATH} {...props} />;
}
